module.exports = __webpack_public_path__ + "4d55cfc29d472cd3655cc95bb6f2184b.pdf";